// Lazy images, iframes
var myLazyLoad = new LazyLoad({
    elements_selector: '.js-lazy',
    class_loading: 'is-loading', 
    class_loaded: 'is-loaded'
});